import { Card } from 'pcln-design-system'
import styled from 'styled-components'

const DropdownCard = styled(Card)`
  max-height: 340px;
  overflow-y: auto;
  border-color: transparent;
  &:focus {
    outline: none;
  }
  ${({ minWidth }) =>
    minWidth &&
    `
    min-width: ${minWidth};
  `}
  display: ${props => (props.visible ? 'block' : 'none')};
  position: absolute;
  z-index: 2;
`

export default DropdownCard
